/* Wishlist — client-side, localStorage. No login required.
   Stores product handles; the wishlist page renders live via /products/{handle}.js.
   Bu dosya iki mağazada BİREBİR aynıdır (tools/parity.mjs); mağazaya özel metin ve
   fiyat biçimi <html lang>'dan seçilir. */
(function () {
  var TR = /^tr/i.test(document.documentElement.lang || '');
  // Anahtarlar mevcut kayıtlı listeler kaybolmasın diye korunur (localStorage zaten origin başına).
  var KEY = TR ? 'dvk_wishlist' : 'stufic_wishlist';
  var T = TR
    ? { from: '', remove: 'Listeden kaldır' }
    : { from: 'From ', remove: 'Remove from wishlist' };

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) {
    var l = read(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    write(l); return l.indexOf(h) > -1;
  }

  function updateCount() {
    var c = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = c;
      el.style.display = c > 0 ? '' : 'none';
    });
  }

  function paintBtn(b, active) {
    b.classList.toggle('is-active', active);
    b.setAttribute('aria-pressed', active ? 'true' : 'false');
    b.innerHTML = active ? '&#9829;' : '&#9825;'; // heart filled / outline
  }
  function markButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      paintBtn(b, has(b.getAttribute('data-wishlist-handle')));
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wishlist-handle');
    if (!h) return;
    var active = toggle(h);
    paintBtn(b, active);
    updateCount();
    if (!active) {
      var card = b.closest('[data-wishlist-card]');
      if (card) { card.remove(); reflectEmpty(); }
    }
  });

  function reflectEmpty() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var any = grid.children.length > 0;
    if (empty) empty.style.display = any ? 'none' : '';
    grid.style.display = any ? '' : 'none';
  }

  function money(cents) {
    // Wall mural: variant is 0.1 m² unit. TR: m² fiyatı = fiyat × 10 (mağaza biçimi "1.250,00 TL");
    // US: per-sq-ft = (price × 10) / 10.7639
    if (TR) return (cents * 10 / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL / m²';
    var sqft = (cents * 10) / 10.7639;
    return '$' + (sqft / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' / sq ft';
  }

  function renderWishlist() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = read();
    if (!list.length) { reflectEmpty(); return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products.forEach(function (p) {
        if (!p) return;
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        var card = document.createElement('div');
        card.className = 'wl-card';
        card.setAttribute('data-wishlist-card', '');
        card.innerHTML =
          '<a class="wl-card__link" href="/products/' + p.handle + '">' +
            '<div class="wl-card__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="wl-card__t">' + (p.title || '') + '</div>' +
            '<div class="wl-card__p">' + T.from + money(p.price) + '</div>' +
          '</a>' +
          '<button type="button" class="wl-card__x" data-wishlist-toggle data-wishlist-handle="' + p.handle + '" aria-label="' + T.remove + '" title="' + T.remove + '">&times;</button>';
        grid.appendChild(card);
      });
      reflectEmpty();
    });
  }

  function init() { updateCount(); markButtons(); renderWishlist(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
